import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";
import {ItemKey} from "../item/core/ItemKey";
import {ExchangeRate} from "./ExchangeRate";


export class ExchangeConfig extends BaseObject {

    constructor() {
        super();

        this._item = null;
        this._currency = null;
        this._rates = [];
    }

    get item() {
        return this._item;
    }

    set item(value) {
        this._item = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get rates() {
        return this._rates;
    }

    set rates(value) {
        this._rates = value;
    }

    valid() {

        if (this.item && (!this.item.valid() || this.item.any())) {
            return false;
        }

        if (this.currency && !CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (this.rates && this.rates.some(v => !v || !v.valid())) {
            return false;
        }

        if (!(this.item || this.currency) || this.rates.length === 0) {
            return false;
        }

        return true;
    }

    empty() {
        return this.rates.length === 0;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ExchangeConfig());
        } else if (target instanceof ExchangeConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ExchangeConfig, {
    _item: alias("item", ItemKey.schema()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _rates: alias("rates", list(ExchangeRate.schema()))
});